export default "__VITE_ASSET__b942bddf__"